import { Input, Textarea } from 'ui'
import { FieldAttributesSignature } from '.'
import { usePDFStore } from '../../../stores/pdf.store'

export const FieldAttributeHelperText: FieldAttributesSignature = ({
  field,
}) => {
  const updateField = usePDFStore((state) => state.updateField)

  return (
    <div className='space-y-2'>
      <label className='font-bold text-sm'>Mensaje de ayuda</label>
      <Textarea
        defaultValue={field.helper_text || ''}
        onChange={(e) =>
          updateField(field.id, {
            helper_text: e.target.value,
          })
        }
      />
    </div>
  )
}
